/* tslint:disable */
/* eslint-disable */
export enum PackageOperation {
  PICKUP = 0,
  TRANSFER_PICKUP = 1,
  DELIVERY = 2,
  TRANSFER_DROP = 3,
  REFUSED = 4,
}
